/**
 * Controls visibility/availability of the Report Designer feature.
 *
 * Reads from window._env_.REPORT_DESIGNER_ENABLED (emitted by env.sh at
 * container start; see designer/env.sh and public/env-config.js):
 * - absent / null / any value other than "false"  → ENABLED (default; current behavior)
 * - "false" (case-insensitive)                     → DISABLED (report designer hidden)
 *
 * WHY this gate exists: the generated-app backend pulls in iText7 (AGPLv3 /
 * commercial dual-licensed) primarily to render Report Designer PDFs. When a
 * deployment disables the Report Designer, the backend code generator also stops
 * emitting iText7 (see Kuika.Designtime.CodeGenerator FeatureFlags.IsReportDesignerEnabled),
 * so generated apps ship with ZERO iText7 reference. This frontend gate keeps the
 * designer and the codegen in lockstep behind the SAME env var name.
 *
 * Opt-out semantics: enabled unless explicitly set to "false", so existing
 * deployments are unaffected until they set REPORT_DESIGNER_ENABLED=false.
 */
export function isReportDesignerEnabled(): boolean {
  // window._env_ is globally typed in src/global.d.ts (KuikaWindowEnv).
  const raw: string | undefined = window._env_?.REPORT_DESIGNER_ENABLED;
  if (raw === undefined || raw === null) return true;
  return raw.trim().toLowerCase() !== "false";
}
